const routes = [
    {
        path: "/conservatory/application/form",
        component: () => import("../pages/ApplicationForm")
    },
    {
        path: "/conservatory/application/login",
        component: () => import("../pages/Login")
    },
    {
        path: "/conservatory/application/register",
        component: () => import("../pages/Register")
    },
    {
        path: "/conservatory/application/forgot/password",
        component: () => import("../pages/ForgotPassword")
    },
    /// Admin
    {
        path: "/conservatory/applications",
        component: () => import("../pages/admin/Index"),
        meta: {
            isAuthenticated: true,
            permission: 'conservatoryapplication_index'
        }
    },

];

export default routes;
